import React from 'react';
import { motion } from 'framer-motion';

function LoadingSpinner() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50"
    >
      <div className="text-center">
        <div className="relative">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            className="w-8 h-8 border-3 border-[#0C1C35] border-t-transparent rounded-full mx-auto mb-3"
          />
        </div>
        <p className="text-slate-600 font-medium">Please wait...</p>
      </div>
    </motion.div>
  );
}

export default LoadingSpinner;